import { Component, Prop, Vue } from 'vue-property-decorator'

import {
  BootstrapInput,
  BootstrapButton,
  BootstrapTextArea,
  BootstrapCheck
} from '../../../dsl/front'
import { AnyObject } from '../../_contracts'
import { WelcomeFormConfig } from '../../../services'

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
@Component<ContactFormTabUI>({
  name: 'ContactFormTabUI',
  components: {
    BootstrapInput,
    BootstrapButton,
    BootstrapTextArea,
    BootstrapCheck
  },

  template: `
  <section>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <form class="row justify-content-center" @submit.prevent="submitForm">
            <div class="col-12 col-sm-9 col-md-10 col-lg-5">
              <!-- Name -->
              <BootstrapInput name="name"
                              autocomplete="name" :required="true" :model.sync="formData.name"
                              :label="$t('_.name-and-surname')" class="mb-3" />

              <!-- E-mail address -->
              <BootstrapInput type="email" name="email" :model.sync="formData.email"
                              autocomplete="email" :required="true"
                              :label="$t('_.email-address')" class="mb-3" />

              <!-- Theme -->
              <BootstrapInput name="subject" :model.sync="formData.theme" :required="true"
                              :label="$t('_.theme')" class="mb-3" />

              <!-- Message -->
              <BootstrapTextArea name="organization" :model.sync="formData.message"
                              autocomplete="organization" :required="true"
                              :label="$t('_.message')" class="mb-3" />

              <div class="text-start">
                <BootstrapCheck name="agreement" :model.sync="formData.agreement"
                                :options="[{
                                label: agreementText,
                                value: true
                              }]" :multiple="true" :required="true" class="mb-5" />
              </div>

              <p v-if="message !== ''" class="text-center">{{message}}</p>

              <!-- "Submit" button -->
              <div class="d-flex justify-content-center">
                <BootstrapButton type="submit" class="contact__form__submit">
                  {{ $t('modules.contact.tabs.contactForm.submit') }}
                </BootstrapButton>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </section>
  `
})
export class ContactFormTabUI extends Vue {
  //
  @Prop({ type: Function, required: true })
  private onSubmit!: (formData: AnyObject) => Promise<void>

  @Prop({ type: Object, required: true })
  private welcomeFormConfig!: WelcomeFormConfig

  /**
   * Message to display
   */
  public message: string = ''

  /**
   * Data entered by the User.
   */
  public formData: {
    name: string|null;
    email: string|null;
    theme: string|null;
    message: string|null;
    agreement: boolean|null;
  } = {
    name: null,
    email: null,
    theme: null,
    message: null,
    agreement: null
  }

  public get agreementText (): string {
    return this.welcomeFormConfig.agreement || this.$t('components.WelcomeForm.agreement') as string
  }

  public submitForm (): void {
    this.onSubmit(this.formData).then(() => {
      this.message = String(this.$t('modules.contact.onSuccess'))
    }).catch(() => {
      this.message = String(this.$t('modules.contact.onError'))
    }).finally(() => {
      this.formData = {
        name: null,
        email: null,
        theme: null,
        message: null,
        agreement: null
      }
    })
  }
}
